import { render, staticRenderFns } from "./BaseDetailedFilter.vue?vue&type=template&id=4db65790"
import script from "./BaseDetailedFilter.vue?vue&type=script&lang=js"
export * from "./BaseDetailedFilter.vue?vue&type=script&lang=js"
import style0 from "./BaseDetailedFilter.vue?vue&type=style&index=0&id=4db65790&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports